<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header"><i class="icon-wrench"></i> Assign Employee To Support A Customer</div>
						<b-form @submit.prevent="checkFormValidity()" method="post">
							<b-form-group
								label="Select Project"
								label-for="projectName"
								label-class="required"
								:label-cols="3"
								:horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.projectId.$dirty ? !$v.form.projectId.$error : null">
								<model-select id="projectName" :options="projectNameDropDownList" v-model="form.projectId" :isError="$v.form.projectId.$dirty ? $v.form.projectId.$error : false" placeholder="Select Project"></model-select>
							</b-form-group>
							<b-form-group
								label="Select Employee"
								label-for="employee-name"
								label-class="required"
								:label-cols="3"
								:horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.projectId.$dirty ? !$v.form.projectId.$error : null">
								<model-select id="employee-name" :options="employeeNameDropDownList" v-model="form.employeeId" :isError="$v.form.employeeId.$dirty ? $v.form.employeeId.$error : false" placeholder="Select Employee"></model-select>
							</b-form-group>
							<div class="form-actions">
								<b-button v-if="$store.getters.canWrite" type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Add Support Employee</b-button>
								&nbsp;
								<b-button type="button" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
							</div>
						</b-form>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<genericTable
							:table-data="customerDetailsTableData"
							:fields="customerSupportDetailsListFields"
							:per-page=50
							hover striped bordered small
							caption="<i class='icon-list'></i> Customer Support Information"
							:filter="true">
						</genericTable>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>

</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators';
import {ModelSelect} from "vue-search-select";
import genericTable from '@/components/GenericTable';
import customerService from "@/services/customerService";
import toastService from "@/services/toastService";


export default {
	name : "SupportManagement",
	components: {
		"genericTable": genericTable,
		ModelSelect
	},
	data : function () {
		return {
			loading : false,
			form : {
				projectId : null,
				employeeId : null
			},
			projectNames : [],
			projectNameDropDownList : [],
			employeeList : [],
			employeeNameDropDownList : [],
			customerSupportDetailsList : [],
			customerSupportDetailsListFields : [
				{key: 'serial', label: '#', sortable: true, searchable: true, class: 'text-center', thStyle: "width: 5%"},
				{key: 'project_name', label: 'Project Name', sortable: true, class: 'text-center', searchable: true},
				{key: 'employee_name', label: 'Employee Name', sortable: true, class: 'text-center', searchable: true},
				{key: 'employee_email', label: 'Employee Email', sortable: true, class: 'text-center', searchable: true}
			],
			serialCounter : 0
		}
	},
	validations : {
		form : {
			projectId : {
				required,
				minValue: minValue(1)
			},
			employeeId : {
				required,
				minValue: minValue(1)
			}
		}
	},
	methods : {
		getProjectNames : function () {
			customerService.getProjectNames((data) => {
				this.projectNames = data;
				this.createProjectNameDropDownList();
				this.loading = false;
			}, (error) => {
				this.loading = false;
				toastService.showErrorToast("Could not fetch project names " + error);
			});
		},
		createProjectNameDropDownList : function () {
			this.projectNames.forEach((value) => {
				let project = new Object();
				project.text = value.name;
				project.value = value.id;
				this.projectNameDropDownList.push(project);
			});
		},
		getAvailableEmployees : function () {
			customerService.getAvailableSupportEmployees((data) => {
				this.employeeList = data;
				this.createEmployeeNameDropDownList();
			}, (error) => {
				toastService.showErrorToast("Could not fetch employee list " + error);
			});
		},
		createEmployeeNameDropDownList : function () {
			this.employeeList.forEach((value) => {
				let employee = new Object();
				employee.text = value.name;
				employee.value = value.id;
				this.employeeNameDropDownList.push(employee);
			});
		},
		checkFormValidity: function(){
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.addEmployeeToSupport();
		},
		addEmployeeToSupport : function () {
			let selectedProject = this.projectNameDropDownList.find((item) => item.value === this.form.projectId);
			let selectedEmployee = this.employeeList.find((item) => item.id === this.form.employeeId);

			const formData = {
				projectId : this.form.projectId,
				projectName : selectedProject.text.trim(),
				supportEmployeeId : this.form.employeeId
			};

			customerService.assignAnEmployeeToSupport(formData, (data) => {
				this.resetForm();
				this.addNewRowToCustomerDetailsTable(selectedProject, selectedEmployee);
				toastService.showSuccessToast("Support information added successfully");
			}, (error) => {
				toastService.showErrorToast("Could not add support information " + error);
			});
		},
		resetForm : function(){
			this.$nextTick(() => { this.$v.$reset() });
			this.form.projectId = null;
			this.form.employeeId = null;
		},
		getAllCustomerDetailsInformation  : function () {
			customerService.getAllCustomerSupportDetails((data) => {
				this.createCustomerSupportDetailsTable(data);
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch expired subscriptoin list " + error);
			});
		},
		createCustomerSupportDetailsTable : function (data) {
			data.forEach((value, index) => {
				let row = new Object();
				row.serial = ++this.serialCounter;
				row.project_name = value.projectName;
				row.employee_name = value.employeeName;
				row.employee_email = value.employeeEmail;
				this.customerSupportDetailsList.push(row);
			});
		},
		addNewRowToCustomerDetailsTable : function (project, employee) {
			let row = new Object();
			row.serial = ++this.serialCounter;
			row.project_name = project.text;
			row.employee_name = employee.name;
			row.employee_email = employee.email;
			this.customerSupportDetailsList.push(row);
		}
	},
	created() {
		this.loading = true;
		this.getProjectNames();
		this.getAvailableEmployees();
		this.getAllCustomerDetailsInformation();
	},
	computed : {
		customerDetailsTableData : function () {
			return this.customerSupportDetailsList;
		}
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
